"use client";
import React from "react";
import DedicatedSupportSection from "../components/LandingPage/DedicatedSupportSection";
import EfficientBackofficeSection from "../components/LandingPage/EfficientBackoffice";
import ProductsSection from "../components/LandingPage/ProductsSection";
import Footer from "../components/Footer";
import HeadingWithChips from "../components/common/HeadingWithChips";
import pictureWithTextBackground from '../assets/trust-section/trust.png';
import PictureWithText from "../components/common/PictureWithText";
import randomGraphic from '../assets/random-graphic.png';
import suite from '../assets/suite.png';
import FirstSection from "../components/common/FirstSection";
import HowToGetStarted from "../components/common/HowToGetStarted";
import WhyChoose from "../components/LandingPage/WhyChoose";
const LandingPage: React.FC = () => {
  const innovationSteps = [
    {
      number: "1",
      title: "AUTOMATED \nAPI PAYOUTS",
      description:
        "",
    },
    {
      number: "2",
      title: "STAY AHEAD WITH 24/7\nPAYMENT PROCESSING",
      description:
        "",
    },
    {
      number: "3",
      title: "VIRTUAL POS \nTERMINALS",
      description:
        "",
    },
  ];
  return (
        <main>
        <FirstSection 
        icon={suite}
        iconAlt="Suite icon"
        backgroundImage={randomGraphic}
        title="EPAYR offers a complete suite of financial services"
        description={
            <>
                  From acquiring, payment gateway services
                  <br />
                  and API integrations to a ready-made e-wallet, currency exchange and
                  bank transfers
            </>
        }
        heading="your trusted financial solution provider"
        buttonText="CONTACT US"
        buttonHref="/contact"
        buttonVariant="lightPurple"
        leftColumnSx={{
            backgroundColor: "beige.200"
        }}
        />
        <WhyChoose/>
        <DedicatedSupportSection />
        <HowToGetStarted steps={innovationSteps} title="INNOVATIVE" highlightedTitle="TECHNOLOGY" innerHeader={true}/>
        <PictureWithText 
            backgroundImage={pictureWithTextBackground} 
            titleSegments={[{ text: "TRUST", color: "darkPurple.500" },
                { text: " & ", color: "lightPurple.500" },
                { text: "Transparency ", color: "darkPurple.500" }]} 
            description={"We uphold our commitments with honesty, responsibility, and transparency—no false promises, just reliable service"}        
        />
        <EfficientBackofficeSection />
        <HeadingWithChips 
              headingPrefix="custom"
              headingHighlight=" solutions"
              headingSuffix=""
              subheading=''
              discussionText={["", " CAN BE FULLY CUSTOMIZED WITHIN ",
                "TO MATCH YOUR BRAND'S COLORS AND ADAPTED TO MEET YOUR UNIQUE UI/UX REQUIREMENTS FOR OPTIMAL RESULTS"]}
              chips = {[
                { text: "OUR SOFTWARE", backgroundColor: "lightPurple.200", textColor: "lightPurple.500" },
                { text: "2 WEEKS",  backgroundColor: "beige.200",  textColor: "beige.700" },
              ]}
              displayIcons={true}
            />
        <ProductsSection/>
        <Footer 
              buttonText="CONTACT US" 
              buttonLink="/contact?type=company"
              ctaText={{
                prefix: '',
                highlight1: 'GET STARTED',
                middle: ' TODAY AND TAKE CONTROL OF YOUR FINANCES WITH',
                highlight2: ' EPAYR',
                suffix: ''
              }}
            />
        </main>
  );
};

export default LandingPage;
